<template>
  <div class="related-users-data col-xs-12 list group">
    <label for="related-users-data">Osoby powiązane ze zleceniem:</label>
    <div>
      <div class="list-group-item list-group-item-overflowed">
        <label>Asystent: </label> {{ assistant ? assistant.fullname : "b.d." }} <br>
        <label>Adres email:</label>
        {{ assistant && assistant.email ? assistant.email : "b.d." }} <br>
        <label>Numer telefonu:</label>
        {{ assistant && assistant.phone ? assistant.phone : "b.d." }} <br>
      </div>
      <div class="related-users-data">
        <ul class="list-group">
          <li class="list-group-item list-group-item-overflowed">
            <label>Analityk: </label> {{ analyst ? analyst.fullname : "b.d." }} <br>
            <label>Numer telefonu:</label>
            {{ analyst && analyst.phone ? analyst.phone : "b.d." }} <br>
          </li>
          <li class="list-group-item list-group-item-overflowed">
            <label>Inspektor: </label>
            {{ inspector ? inspector.fullname : "b.d." }} <br>
          </li>
          <li class="list-group-item list-group-item-overflowed">
            <label>Rzeczoznawca: </label>
            {{ appraiser ? appraiser.fullname : "b.d." }} <br>
            <label>Adres email:</label>
            {{ appraiser && appraiser.email ? appraiser.email : "b.d." }} <br>
            <label>Numer telefonu:</label>
            {{ appraiser && appraiser.phone ? appraiser.phone : "b.d." }} <br>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RelatedUsersMain",
  props: {
    relatedUsersData: null,
  },
  methods: {
    findUserWithRole(role) {
      return this.relatedUsersData.find(
        (relatedUser) => relatedUser.role === role
      );
    },
  },
  computed: {
    analyst() {
      return this.findUserWithRole("ROLE_ANALITYK");
    },
    inspector() {
      return this.findUserWithRole("ROLE_INSPEKTOR");
    },
    appraiser() {
      return this.findUserWithRole("ROLE_RZECZOZNAWCA_ZEWN");
    },
    assistant() {
      return this.findUserWithRole("ROLE_ASYSTENT_BWN");
    },
  },
};
</script>

<style>
</style>